export default {

  /**
   *
   * @param {String} str
   * @param {String} searchInput
   */
  fillSearchResult: (str, searchInput) => {
    if (!str.toLowerCase().includes(searchInput.toLowerCase())) {
      return str
    }
    const escapedChars = ['$', '^', '.', '*', '+', '?', '', '/', '{', '}', '[', ']', '(', ')', '|']
    const escapedSearchInput = searchInput.split('').map(i => escapedChars.includes(i) ? `\\${i}` : i).join('')
    const reg = new RegExp(escapedSearchInput, 'gi')
    return str.replaceAll(reg, match => `<span class="search-result-background">${match}</span>`)
  }
}
